import {FC} from "react";
import {ReportPage, ReportSalesInGraphSearchPanel} from "../../../components";
import {getPageNameByPageId, getSystemLanguageId, getUserId} from "../../../utils";
import {searchReportSalesAndPurchaseInGraph} from "../../../serviceBroker/transationReportApiServiceBroker";
import {PageEnum, SalesInGraphReportSearchParamsModel} from "../../../models";

export const ReportSalesAndPurchaseInGraph: FC = () => {
    const initialState: SalesInGraphReportSearchParamsModel = {
        Lang:getSystemLanguageId(),
        userId: getUserId(),
    };
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportSalesAndPurchaseInGraph}
            searchHeader={getPageNameByPageId(PageEnum.ReportSalesAndPurchaseGraph)}
            SearchPanel={ReportSalesInGraphSearchPanel}
            formId={PageEnum.ReportSalesAndPurchaseGraph}
        />
    );
};
